import {isHTMLOrSVGElement, setRef} from '@esgi/ui-kit/utils';
import {PureComponent, Ref} from 'react';
import {findDOMNode} from 'react-dom';

export function getKeyboardFocusableElements(element: Element): Element[] {
	if (!element) {
		return [];
	}

	return Array.from(element.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'))
		.filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export type NavigatorManager = {
	forward: () => boolean;
	back: () => boolean;
}

type Props = {
	navigatorManager: Ref<NavigatorManager>;
	children: any;
}

class NavigatorImpl {
	constructor(private target: () => Element | Text) {
	}

	public forward(): boolean {
		const candidates = this.candidates;
		if (candidates.length) {
			const current = document.activeElement;
			const currentIndex = candidates.indexOf(current);

			let nextIndex = currentIndex + 1;
			if (nextIndex > (candidates.length - 1)) {
				nextIndex = 0;
			}
			return this.focusElement(candidates[nextIndex]);
		}
	}

	public back(): boolean {
		const candidates = this.candidates;
		if (candidates.length) {
			const current = document.activeElement;
			const currentIndex = candidates.indexOf(current);

			let nextIndex = currentIndex - 1;
			if (nextIndex < 0) {
				nextIndex = candidates.length - 1;
			}

			return this.focusElement(candidates[nextIndex]);
		}
	}

	private get candidates(): Element[] {
		const scope = this.target();
		if (scope instanceof Element) {
			return Array.from(getKeyboardFocusableElements(scope));
		}
		return [];
	}

	private focusElement = (element: Element): boolean => {
		if (element && isHTMLOrSVGElement(element)) {
			element.focus();
			return true;
		}
		return false;
	};
}

export class ElementsNavigator extends PureComponent<Props> {
	private navigator = new NavigatorImpl(() => {
		try {
			return findDOMNode(this);
		} catch (e) {

		}
		return null;
	});

	public override componentDidMount() {
		setRef(this.navigator, this.props.navigatorManager);
	}

	public override componentDidUpdate(prevProps: Readonly<Props>) {
		if (prevProps.navigatorManager !== this.props.navigatorManager) {
			setRef(this.navigator, this.props.navigatorManager);
		}
	}

	public override render() {
		return this.props.children;
	}

	public override componentWillUnmount() {
		this.navigator = null;
	}
}
